import React from 'react';
import cx from 'classnames';
import { FormInputWithTitle } from '../../../components/FormFields';

const DashboardObjectivesFormField = ({ title, description, placeholder, value, error, onChange, disabled = false }) => {
  return (
    <div className={cx('dashboard-objectives-field', { 'dashboard-objectives-field-disabled': disabled })}>
      <h4 className="dashboard-objectives-field-label">{title}</h4>
      <div className="dashboard-objectives-field-description">{description}</div>
  
      <FormInputWithTitle
        type="number"
        min={0}
        step={1}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      
      {error ? (
        <div className="dashboard-objectives-field-error">{error}</div>
      ) : null}
    </div>
  );
};

export default DashboardObjectivesFormField;